import { Container } from '@ui/wrapper'
import SectionTitle from '@ui/section-title'
import { SectionWrapper, StyledText } from './style'

const DatenschutzArea = ({ data, ...rest }) => {
  return (
    <SectionWrapper {...rest}>
      <Container>
        {data?.section_title && (
          <SectionTitle
            mb={['30px', null, '40px']}
            subtitle={data.section_title?.subtitle}
            title={data.section_title?.title}
          />
        )}
        {data?.texts?.map((text, i) => (
          <StyledText
            dangerouslySetInnerHTML={{
              __html: text.content
            }}
            key={i}
          />
        ))}
      </Container>
    </SectionWrapper>
  )
}

export default DatenschutzArea
